

import _Abstract from "system/abstract"

export default class Module_Accordion extends _Abstract {
    constructor(el, options)
    {
        super(el, $.extend(true, {}, options), 'module')
        this.initModule();
    }

    initModule()
    {
        var $accordianItems = this.$el.find(".m-accordion__item");
        var $accordianLinks = this.$el.find(".m-accordion__title");
        var $accordianContent;

        $accordianLinks.on("click", function()
        {
            var $accordianItem = $(this).closest(".m-accordion__item");
            $accordianItems.not($accordianItem).removeClass("is-open");
            if($accordianItem.hasClass("is-open"))
            {
                $accordianItem.removeClass("is-open");
            }
            else
            {
                $accordianItem.addClass("is-open");
            }
        });
    }
}




/** WEBPACK FOOTER **
 ** ./modules/accordion.js
 **/